import { render } from "./StatefulPopover.vue?vue&type=template&id=96117854"
import script from "./StatefulPopover.vue?vue&type=script&lang=js"
export * from "./StatefulPopover.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__